import type { DimensionKey } from '../interpretiveReportView';
import styles from '../InterpretiveReportPage.module.css';

const PATHS: Record<DimensionKey, string[]> = {
  openness: ['M4 5h16v11H9l-5 4V5z', 'M12 8.5v3.5M12 14.2v.3'],
  recognition: ['M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z'],
  inclusion: [
    'M9 4.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z',
    'M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6',
    'M15 4.8a3.3 3.3 0 0 1 0 6.4',
    'M17.5 14.3c2.3.7 4 2.7 4 5.7',
  ],
  trust: [
    'M2 12l4-5 4 1 3-2 4 1 5 5',
    'M6 7l-4 5 6 6',
    'M10 8l-3 3 1.5 1.5L12 10l5.5 5.5a1.4 1.4 0 0 1-2 2L13 15',
    'M8 18l1.5 1.5a1.4 1.4 0 0 0 2-2',
    'M11 16l2 2a1.4 1.4 0 0 0 2-2',
  ],
};

/** The symbol of a dimension; a dimension the report does not know gets an empty tile */
export const DimensionIcon = ({ dimension }: { dimension: DimensionKey | null }) => (
  <span aria-hidden="true" className={styles.icon}>
    {dimension && (
      <svg
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {PATHS[dimension].map((path) => (
          <path key={path} d={path} />
        ))}
      </svg>
    )}
  </span>
);
